import { Tooltip } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import type { IntlMessageId } from '@/types/intl';

export function InfoPill({ messageId }: { messageId: IntlMessageId }) {
  return (
    <Tooltip position="right" contents={<FormattedMessage id={messageId} />}>
      <div className="badge badge-dismissible">
        <em className="icon icon-sm cursor-default line-height-1 text-secondary">info_outline</em>
      </div>
    </Tooltip>
  );
}
